export const defaultLocale = 'en-US'
export const defaultLanguageCode = 'en'
